var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 754.17,
    height: 803.293,
    viewBox: "0 0 754.17 803.293",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-500.657 -133.672)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.568,
    cy: 35.568,
    r: 35.568,
    transform: "translate(583.343 156.689)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.352,217.542l-.2.194v-.194l-.005.2c-2.726,2.651-33.081,32.6-44.857,62.983-3.909-4.349-6.674-7-6.674-7l-.131.127v-.127l0,.13c-2.222,2.16-32.439,31.979-32.439,55.608,0,22.814,12.614,31.817,28.849,32.966l-1.178,22.5h3.29l.364-22.389c.414.009.829.016,1.247.016,12,0,22.471-3.818,28.124-13.631a58.107,58.107,0,0,0,17.932,3.957l-1.8,34.334h5.02l.555-34.159c.632.014,1.265.024,1.9.024,27.447,0,49.7-13.068,49.7-50.5S708.352,217.542,708.352,217.542Z",
    transform: "translate(397.618 103.308)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.709,247.037V227.344H588.166v19.693h-33.68v-77.9H522.1V138.962H449.558v30.179H415.877V291.427a181.922,181.922,0,0,0-15.685-14.5l-.158.127v-.127l0,.13c-2.67,2.16-38.987,31.979-38.987,55.608,0,22.814,15.16,31.817,34.673,32.966l-1.416,22.5h3.954l.437-22.389c.5.009,1,.016,1.5.016a61.8,61.8,0,0,0,15.685-1.844v29.415H693.094V247.037Z",
    transform: "translate(320.498 98.593)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.345,
    cy: 12.568,
    rx: 136.345,
    ry: 12.568,
    transform: "translate(518.135 507.767)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.741,283.02c0,61.894-36.795,83.5-82.184,83.5s-82.184-21.611-82.184-83.5,82.184-140.633,82.184-140.633S438.741,221.126,438.741,283.02Z",
    transform: "translate(370.406 97.459)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.6,310.519l.842-51.8,35.029-64.084-34.9,55.958.378-23.292L245.1,180.939l-24.042,40.2h0l.681-41.891,25.852-36.911-25.745,30.323.426-76.812L219.6,197.535l.22-4.195-26.284-40.232,25.862,48.284-2.449,46.784-.073-1.242-30.3-42.337,30.208,46.724-.306,5.85-.055.088.025.481-6.213,118.7h8.3l1-61.309,30.134-46.609Z",
    transform: "translate(504.366 143.998)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.024,283.02c0,61.894-36.795,83.5-82.184,83.5s-82.184-21.611-82.184-83.5S222.84,142.387,222.84,142.387,305.024,221.126,305.024,283.02Z",
    transform: "translate(360 97.459)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.887,310.519l.842-51.8,35.028-64.084-34.9,55.958.378-23.292,24.142-46.364-24.042,40.2h0l.681-41.891,25.85-36.911L88.127,172.661l.425-76.812L85.879,197.535l.22-4.195L59.815,153.108l25.862,48.284-2.449,46.784-.073-1.242L52.856,204.6l30.208,46.724-.306,5.85-.055.088.025.481-6.213,118.7h8.3l1-61.309,30.134-46.609Z",
    transform: "translate(493.96 143.998)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.922,236.707c0,83.7-49.756,112.919-111.132,112.919S189.657,320.4,189.657,236.707,316.393,43.672,316.393,43.672,411.922,153.012,411.922,236.707Z",
    transform: "translate(363.813 90)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.607,290.286l1.138-70.046,47.367-86.657-47.188,75.669.511-31.5,32.646-62.695-32.51,54.36h0l.92-56.646,34.957-49.913-34.813,41.006L165.21,0,161.6,137.5l.3-5.673-35.541-54.4,34.972,65.291-3.312,63.264-.1-1.679-40.973-57.251,40.849,63.183-.415,7.911-.074.119.035.65-8.4,160.505H160.16l1.346-82.9,40.749-63.027Z",
    transform: "translate(498.947 136.539)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.556,802.3,510.3,851.879c-24.776-10.864-41.226-29.352-49.576-55.257l55.257-49.576C516.328,779.621,533.2,797.74,565.556,802.3Z",
    transform: "translate(282.011 -39.548)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.085,
    height: 1.077,
    transform: "translate(754.564 761.704) rotate(-40.499)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.442,
    height: 1.077,
    transform: "translate(759.659 768.954) rotate(-42.059)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.47,636.631l-73.825,7.812c-13.716-23.318-16.219-47.938-7.812-73.825l73.825-7.812C562.859,589.412,565.916,613.978,589.47,636.631Z",
    transform: "translate(396.253 108.684)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.085,
    height: 1.077,
    transform: "translate(910.962 689.98) rotate(-4.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.442,
    height: 1.077,
    transform: "translate(910.852 698.843) rotate(-6.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.149,493.692,474.8,438.235c10.964-24.732,29.518-41.107,55.457-49.352l49.352,55.457C547.029,444.556,528.842,461.35,524.149,493.692Z",
    transform: "translate(386.004 116.642)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.077,
    height: 49.085,
    transform: "matrix(0.763, -0.646, 0.646, 0.763, 910.759, 518.027)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.077,
    height: 48.442,
    transform: "matrix(0.745, -0.667, 0.667, 0.745, 903.514, 523.122)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(876.807 283.703)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.01,
    cy: 12.889,
    rx: 189.01,
    ry: 12.889,
    transform: "translate(0 627.484)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.844,
    height: 120.3,
    transform: "translate(28.761 124.947) rotate(-30)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.239,
    height: 0.904,
    transform: "matrix(0.858, -0.514, 0.514, 0.858, 44.823, 145.91)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.239,
    height: 0.904,
    transform: "matrix(0.858, -0.514, 0.514, 0.858, 50.25, 153.388)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.239,
    height: 0.904,
    transform: "matrix(0.858, -0.514, 0.514, 0.858, 56.581, 159.72)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.239,
    height: 0.904,
    transform: "matrix(0.858, -0.514, 0.514, 0.858, 62.008, 167.86)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.24,
    height: 0.904,
    transform: "matrix(0.858, -0.514, 0.514, 0.858, 67.435, 179.619)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.086,375.051s23.283-11.2,39.851-7.024L736.086,260.548V249.512l56.407,134.21h0c14.1,26.583,31.933,87.172,1.534,92.035-34.489,5.518-96.568,26.211-96.568,26.211l-13.8-120.021Z",
    transform: "translate(-511.609 -142.529)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.313,345.072s-37.248-46.9-46.9-30.35,43.369,44.4,43.369,44.4Z",
    transform: "translate(-497.722 -148.418)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.494,349.3l-15.175-8.277s-9.657,24.832-9.657,28.971,15.175,5.518,15.175,5.518Z",
    transform: "translate(-501.487 -151.268)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.868,
    cy: 35.868,
    r: 35.868,
    transform: "translate(125.793 25.974)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.21,190.03s15.175,45.525,26.211,48.284-42.766,23.452-42.766,23.452-16.555-38.627-24.832-48.284S695.21,190.03,695.21,190.03Z",
    transform: "translate(-508.671 -136.849)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.628,474.863c29.736-4.758,13.323-62.839-.607-90.252a18.268,18.268,0,0,1,3.366,3.34c13.8,17.934,41.386,95.189,6.9,100.707s-96.568,26.211-96.568,26.211l-1.877-16.329C714.579,492.847,758.584,479.19,785.628,474.863Z",
    transform: "translate(-512.867 -155.43)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.212,746.723s34.489,27.591,31.73,30.35-31.73,46.9-56.561,51.043-35.868,4.139-35.868,0,6.9-13.8,19.314-17.934,13.8-31.73,12.416-37.248S841.212,746.723,841.212,746.723Z",
    transform: "translate(-520.857 -190.008)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.823,519.47,748.9,622.936s91.05,102.086,88.291,103.466-30.35,28.971-35.868,28.971-100.707-107.6-100.707-107.6L666.123,558.1Z",
    transform: "translate(-509.934 -168.307)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740,482.348s-11.036,46.9-41.386,78.634-44.146,96.568-44.146,96.568l-30.35,129.677s-53.8-6.9-51.043-20.693l28.971-114.5s33.109-158.648,51.043-169.684S740,482.348,740,482.348Z",
    transform: "translate(-501.039 -164.294)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.242,806.42s8.277,26.211,2.759,28.97-103.466,8.277-108.984-11.036c0,0-2.759-9.657,19.314-9.657S573.856,794,573.856,794Z",
    transform: "translate(-494.922 -194.523)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.23,259.727s35.868-35.868,45.525-33.109,9.657,16.555,9.657,16.555,30.35,4.139,27.591,103.466S776.835,457,767.178,462.521s-120.021,30.35-124.159,5.518S640.26,348.018,651.3,317.668,676.128,268,669.23,259.727Z",
    transform: "translate(-507.523 -140.329)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.184,272.365s41.386,19.314,17.934,56.561S685.731,406.181,660.9,404.8,597.44,379.97,586.4,379.97s4.139-40.007,12.416-41.386,46.9,22.073,46.9,22.073S659.52,266.847,709.184,272.365Z",
    transform: "translate(-501.951 -144.689)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.841,192.04c-3.06-.183-6.047.852-9.086,1.255-10.871,1.443-22.18-6.445-24.581-17.146a13.157,13.157,0,0,0-1.257-4.1c-1.673-2.732-5.484-3.252-8.625-2.624s-6.119,2.1-9.318,2.266c-4.939.259-9.681-2.782-12.313-6.969s-3.378-9.34-3.022-14.273l2.368,2.485a12.027,12.027,0,0,0,1.072-6.536,7.585,7.585,0,0,1,7.185,1.838c2.088.222.512-3.873,2.063-5.288a3.588,3.588,0,0,1,2.525-.472c4.442.043,8.035-3.354,11.535-6.089a49.016,49.016,0,0,1,20.7-9.443c5.015-.978,10.349-1.135,15.105.732,3.906,1.534,7.176,4.327,10.2,7.236,7.447,7.161,14.041,15.574,17.139,25.43a42.809,42.809,0,0,1,.2,24.823c-1.248,4.213-5.01,18.643-10.518,18.979C689.3,204.569,693.455,192.554,684.841,192.04Z",
    transform: "translate(-502.488 -126.235)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.875e087aa1b3192307e6d6a3a1576212.svg";
export { ForwardRef as ReactComponent };